import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SidebarAdmin from './sidebaradmin';

import TextField from '@mui/material/TextField';

import {
  Link
} from "react-router-dom";




const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));



function AddLocation () {
    React.useEffect(() => {
        if (document.body.classList.contains('adminbody_bg')) {
          document.body.classList.remove('body');
        }
        document.body.classList.add('adminbody_bg');
      }, []);


      const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };


  const top100Films = [
    { title: 'DR. M. CONTI SCHOOL' },
    { title: 'F R CONWELL MIDDLE SCH'},
    { title: 'HEIGHTS MIDDLE SCHOOL' },
    { title: 'M.L.KING JR. SCHOOL'},
    { title: 'M.L.KING JR. SCHOOL'},
   
  ];
  
  return (
    <Box sx={{ display: 'flex' }}>
    
    <SidebarAdmin />
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <DrawerHeader />
      <Typography paragraph>
            <div className='row'>
              <div className='col-md-12'>
                <div className='club-sec application-sec'>
                  <div className='container-fluid '>
                    <div className="admin-body-heading forms-heading-sec">
                      <h2>Add Location</h2>
                      <Link to="/admin/managelocation"> <p className='stts-sec  go-frm-cols go-new-add mange-ur'>Manage Location</p>

<div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
  <div class="scroll-prompt-arrow-container new-go-spp">
    <div class="scroll-prompt-arrow"><div></div></div>
    <div class="scroll-prompt-arrow new-scroll"><div></div></div>
  </div>
</div>
</Link>
                    </div>

                      <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec admin-top-sec' style={{marginTop:'5px'}}>
                        <div className='row'>
                         

                          <div className='col-md-3'>
                            <div className='login-secs login-secsss login-secssss admn-field'>
                                <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                                }}
                                noValidate
                                autoComplete="off"
                                >

                                <TextField id="standard-basic" label="Location Name" variant="standard" className='requireds'
                                      
                              name="username"
                              />
                          
                                </Box>
                            </div>
                          </div>

                          <div className='col-md-3'>
                            <div className='login-secs login-secsss login-secssss admn-field'>
                                <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                                }}
                                noValidate
                                autoComplete="off"
                                >

                                <TextField id="standard-basic" label="Location No" variant="standard"  className='requireds'
                                      
                              name="username"
                              />
                          
                                </Box>
                            </div>
                          </div>


                       


                         


                        </div>

                      

                        <div className='row'>
                          <div className='col-md-12'>
                            <div class="login-submit login-submitss btn-adm">
                            <button class="btn btn-login btn-submit bt-forms">Submit</button>
                            <button class="btn btn-login btn-submit bt-forms btn-reset">Reset</button>
                            </div>
                          </div>
                        </div>
                  
                      </div>
                  </div>
                </div>
              </div>
            </div>

                    
      </Typography>
     
    </Box>
  </Box>
);
}
export default AddLocation;

